var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntegrationImg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 347,
    height: 247,
    viewBox: "0 0 347 247",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.286 0.375793C78.6335 0.375793 2.71875 76.2972 2.71875 169.943C2.71875 197.486 9.28644 223.504 20.9431 246.498H323.63C335.286 223.504 341.854 197.486 341.854 169.943C341.854 76.2972 265.932 0.375793 172.286 0.375793Z",
    fill: "url(#paint0_linear_6200_202126)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M259.121 45.0773C260.593 45.0773 261.786 43.8845 261.786 42.413C261.786 40.9415 260.593 39.7486 259.121 39.7486C257.65 39.7486 256.457 40.9415 256.457 42.413C256.457 43.8845 257.65 45.0773 259.121 45.0773Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1625 203.861H27.6912V201.39C27.6912 201.03 27.3982 200.737 27.0385 200.737C26.6788 200.737 26.3857 201.03 26.3857 201.39V203.861H23.9145C23.5548 203.861 23.2617 204.154 23.2617 204.514C23.2617 204.873 23.5548 205.166 23.9145 205.166H26.3857V207.638C26.3857 207.997 26.6788 208.29 27.0385 208.29C27.3982 208.29 27.6912 207.997 27.6912 207.638V205.166H30.1625C30.5221 205.166 30.8152 204.873 30.8152 204.514C30.8152 204.154 30.5221 203.861 30.1625 203.861Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M344.971 229.159H342.5V226.688C342.5 226.328 342.207 226.035 341.847 226.035C341.487 226.035 341.194 226.328 341.194 226.688V229.159H338.723C338.363 229.159 338.07 229.452 338.07 229.812C338.07 230.172 338.363 230.465 338.723 230.465H341.194V232.936C341.194 233.296 341.487 233.589 341.847 233.589C342.207 233.589 342.5 233.296 342.5 232.936V230.465H344.971C345.331 230.465 345.624 230.172 345.624 229.812C345.624 229.452 345.331 229.159 344.971 229.159Z",
    fill: "url(#paint1_linear_6200_202126)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M245.323 63.0612V56.5136C245.323 55.8738 244.801 55.3516 244.161 55.3516H242.477C241.981 55.3516 241.55 55.0187 241.439 54.5356C240.858 51.9897 239.859 49.607 238.521 47.4593C238.253 47.0284 238.305 46.4735 238.664 46.121L239.852 44.9329C240.303 44.4825 240.303 43.7448 239.852 43.2944L235.224 38.6661C234.774 38.2156 234.036 38.2156 233.586 38.6661L232.404 39.8476C232.045 40.2067 231.49 40.2589 231.066 39.9913C228.918 38.653 226.529 37.6542 223.983 37.0732C223.5 36.9623 223.167 36.5249 223.167 36.0353V34.3576C223.167 33.7179 222.645 33.1956 222.005 33.1956H215.457C214.818 33.1956 214.295 33.7179 214.295 34.3576V36.0353C214.295 36.5314 213.962 36.9623 213.479 37.0732C210.933 37.6542 208.551 38.653 206.396 39.9913C205.966 40.2589 205.411 40.2067 205.058 39.8476L203.877 38.6661C203.426 38.2156 202.689 38.2156 202.238 38.6661L197.61 43.2944C197.159 43.7448 197.159 44.4825 197.61 44.9329L198.791 46.1145C199.15 46.4735 199.203 47.0284 198.935 47.4527C197.597 49.6004 196.598 51.9897 196.017 54.5356C195.906 55.0187 195.469 55.3516 194.979 55.3516H193.295C192.655 55.3516 192.133 55.8738 192.133 56.5136V63.0612C192.133 63.7009 192.655 64.2231 193.295 64.2231H194.979C195.475 64.2231 195.906 64.5561 196.017 65.0391C196.604 67.585 197.597 69.9678 198.935 72.1155C199.203 72.5463 199.15 73.1012 198.791 73.4537L197.603 74.6418C197.153 75.0922 197.153 75.8299 197.603 76.2803L202.232 80.9087C202.682 81.3591 203.42 81.3591 203.87 80.9087L205.058 79.7206C205.417 79.3615 205.972 79.3093 206.396 79.577C208.544 80.9152 210.933 81.9075 213.473 82.495C213.956 82.6059 214.289 83.0433 214.289 83.5329V85.2237C214.289 85.8634 214.811 86.3857 215.451 86.3857H221.998C222.638 86.3857 223.16 85.8634 223.16 85.2237V83.5329C223.16 83.0368 223.493 82.6059 223.976 82.495C226.516 81.914 228.905 80.9217 231.053 79.577C231.484 79.3093 232.032 79.3615 232.391 79.7206L233.579 80.9087C234.029 81.3591 234.767 81.3591 235.218 80.9087L239.846 76.2803C240.296 75.8299 240.296 75.0922 239.846 74.6418L238.658 73.4537C238.299 73.0947 238.247 72.5398 238.514 72.1155C239.852 69.9678 240.845 67.5785 241.432 65.0391C241.543 64.5561 241.981 64.2231 242.47 64.2231H244.154C244.794 64.2231 245.316 63.7009 245.316 63.0612H245.323ZM218.715 75.1379C210.241 75.1379 203.374 68.264 203.374 59.7841C203.374 51.3043 210.235 44.4433 218.715 44.4433C227.195 44.4433 234.056 51.3173 234.056 59.7841C234.056 68.2509 227.195 75.1379 218.715 75.1379Z",
    fill: "#507CD9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M198.182 41.0357V37.3148C198.182 36.9492 197.888 36.6555 197.522 36.6555H196.563C196.282 36.6555 196.034 36.4662 195.969 36.192C195.636 34.7493 195.074 33.3915 194.311 32.1707C194.16 31.9292 194.187 31.6093 194.389 31.407L195.061 30.7346C195.316 30.48 195.316 30.0622 195.061 29.8011L192.431 27.1703C192.176 26.9157 191.758 26.9157 191.497 27.1703L190.825 27.8427C190.622 28.0451 190.309 28.0777 190.061 27.921C188.84 27.1572 187.482 26.5958 186.033 26.2629C185.759 26.1976 185.57 25.9496 185.57 25.6689V24.7158C185.57 24.3502 185.276 24.0565 184.91 24.0565H181.189C180.824 24.0565 180.53 24.3502 180.53 24.7158V25.6689C180.53 25.9496 180.341 26.1976 180.067 26.2629C178.617 26.5958 177.266 27.1572 176.039 27.921C175.797 28.0712 175.477 28.0451 175.275 27.8427L174.603 27.1703C174.348 26.9157 173.93 26.9157 173.669 27.1703L171.038 29.8011C170.784 30.0557 170.784 30.4735 171.038 30.7346L171.711 31.407C171.913 31.6093 171.946 31.9227 171.789 32.1707C171.025 33.3915 170.464 34.7493 170.131 36.1985C170.066 36.4727 169.818 36.662 169.537 36.662H168.577C168.212 36.662 167.918 36.9558 167.918 37.3213V41.0423C167.918 41.4078 168.212 41.7016 168.577 41.7016H169.537C169.818 41.7016 170.066 41.8909 170.131 42.1651C170.464 43.6078 171.025 44.9656 171.789 46.1863C171.939 46.4279 171.913 46.7477 171.711 46.9501L171.038 47.6225C170.784 47.8771 170.784 48.2949 171.038 48.556L173.669 51.1868C173.924 51.4414 174.342 51.4414 174.603 51.1868L175.275 50.5144C175.477 50.312 175.791 50.2794 176.039 50.4361C177.26 51.1998 178.617 51.7612 180.06 52.0942C180.334 52.1594 180.524 52.4075 180.524 52.6882V53.6478C180.524 54.0134 180.817 54.3071 181.183 54.3071H184.904C185.269 54.3071 185.563 54.0134 185.563 53.6478V52.6882C185.563 52.4075 185.752 52.1594 186.027 52.0942C187.469 51.7612 188.827 51.1998 190.048 50.4361C190.289 50.2859 190.609 50.312 190.812 50.5144L191.484 51.1868C191.739 51.4414 192.156 51.4414 192.418 51.1868L195.048 48.556C195.303 48.3014 195.303 47.8836 195.048 47.6225L194.376 46.9501C194.174 46.7477 194.141 46.4344 194.298 46.1863C195.061 44.9656 195.623 43.6078 195.956 42.1651C196.021 41.8909 196.269 41.7016 196.55 41.7016H197.509C197.875 41.7016 198.169 41.4078 198.169 41.0423L198.182 41.0357ZM183.056 46.9109C178.787 46.9109 175.327 43.4446 175.327 39.1753C175.327 34.906 178.787 31.4461 183.056 31.4461C187.326 31.4461 190.786 34.9125 190.786 39.1753C190.786 43.438 187.326 46.9109 183.056 46.9109Z",
    fill: "#507CD9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M274.947 59.7842H78.207C70.7296 59.7842 64.668 65.8458 64.668 73.3232V200.182C64.668 207.659 70.7296 213.721 78.207 213.721H274.947C282.425 213.721 288.487 207.659 288.487 200.182V73.3232C288.487 65.8458 282.425 59.7842 274.947 59.7842Z",
    fill: "#7793A9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M282.996 73.9107V188.118C282.996 190.213 281.299 191.911 279.203 191.911H73.9568C71.8613 191.911 70.1641 190.213 70.1641 188.118V73.9107C70.1641 68.8972 74.2245 64.8368 79.238 64.8368H273.922C278.936 64.8368 282.996 68.8972 282.996 73.9107Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M197.925 246.563H155.219L159.703 220.536L160.879 213.721H192.265L193.44 220.536L197.925 246.563Z",
    fill: "#AAD4F5"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M193.444 220.536H159.707L160.882 213.721H192.269L193.444 220.536Z",
    fill: "#DDE5EB"
  }), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M212.075 240.968H141.07V246.563H212.075V240.968Z",
    fill: "#489DDF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M272.507 207.428H227.953V211.508H272.507V207.428Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M272.507 207.428H262.461V211.508H272.507V207.428Z",
    fill: "#7EC4E0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M236.883 211.508V246.256",
    stroke: "#7EC4E0",
    strokeWidth: 0.652799,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M270.188 211.508V246.256",
    stroke: "#7EC4E0",
    strokeWidth: 0.652799,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M270.189 238.194H236.883",
    stroke: "#7EC4E0",
    strokeWidth: 0.652799,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M265.064 238.194H231.758",
    stroke: "white",
    strokeWidth: 0.652799,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M231.758 211.508V246.256",
    stroke: "white",
    strokeWidth: 0.652799,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M265.066 211.508V246.256",
    stroke: "white",
    strokeWidth: 0.652799,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M246.47 238.018L245.511 241.51C245.511 241.51 242.299 242.503 241.02 241.863L241.457 237.809",
    fill: "#FFA49A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M241.125 240.916C241.125 240.916 240.935 241.687 240.622 242.555C240.113 243.142 239.8 243.521 239.623 243.828C238.99 244.918 239.695 246.243 239.695 246.243H247.026C247.026 246.243 247.698 244.265 247.026 243.41C246.719 243.018 245.583 241.249 245.583 241.249C245.583 241.249 243.625 241.439 241.118 240.923L241.125 240.916Z",
    fill: "#283770"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M215.189 238.194L214.602 241.197C214.602 241.197 216.436 241.987 219.158 241.889L220.176 238.664L215.183 238.188L215.189 238.194Z",
    fill: "#D99490"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M206.523 246.256H219.487C219.487 246.256 220.897 243.945 219.383 241.19C219.383 241.19 217.013 241.393 214.722 240.59C214.722 240.59 213.142 241.608 211.216 242.6C209.199 243.645 206.17 244.546 206.529 246.256H206.523Z",
    fill: "#283770"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M254.225 207.428H241.6C238.676 208.041 233.989 210.861 230.072 211.129C229.426 215.77 227.839 220.059 226.259 223.963C224.719 227.762 221.442 235.857 220.201 239.578C219.379 239.545 217.283 239.382 215.012 238.436C216.526 230.008 219.921 211.501 220.848 207.859C222.173 202.656 225.411 200.612 228.864 199.829C232.109 199.098 233.055 198.896 236.104 198.217L244.329 196.343L254.01 193.974C254.01 193.974 254.212 195.227 254.389 196.937C255.544 201.905 255.4 205.495 254.225 207.428Z",
    fill: "url(#paint2_linear_6200_202126)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M266.406 207.428H262.463C262.463 207.428 261.183 210.313 253.82 211.103C253.382 213.943 252.893 215.751 251.45 221.13C250.575 224.387 246.104 240.107 246.104 240.107C243.453 240.57 241.031 239.578 241.031 239.578C241.031 239.578 242.285 215.287 242.67 211.671C242.813 210.274 243.558 205.267 243.832 204.027C244.596 200.58 247.226 199.163 247.52 199C247.54 198.994 249.035 198.556 250.562 198.217L258.787 196.343L267.835 193.386C267.835 193.386 268.671 195.227 268.847 196.937C269.937 201.624 268.827 207.238 266.412 207.428H266.406Z",
    fill: "url(#paint3_linear_6200_202126)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M244.014 165.094L235.325 173.724C235.325 173.724 232.649 172.229 228.68 170.055C224.711 167.881 221.518 166.791 221.518 166.791L220.48 168.88C220.48 168.88 229.626 177.588 234.457 179.259C234.49 179.272 234.529 179.286 234.561 179.299C234.718 179.351 234.868 179.397 235.018 179.429C235.26 179.481 235.521 179.527 235.815 179.553C239.98 179.932 248.172 171.184 248.172 171.184L244.02 165.1L244.014 165.094Z",
    fill: "#D99490"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M235.974 182.197H222.938C222.637 182.197 222.376 182.001 222.298 181.714L217.036 162.972C216.919 162.548 217.239 162.13 217.676 162.13H230.712C231.013 162.13 231.274 162.326 231.352 162.613L236.614 181.355C236.731 181.779 236.411 182.197 235.974 182.197Z",
    fill: "url(#paint4_linear_6200_202126)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M252.803 169.487L248.501 173.117L246.268 175.003L244.754 176.283C240.707 172.934 238.461 170.133 238.461 170.133C244.29 163.853 247.346 161.516 247.391 161.484C248.364 160.726 252.803 169.487 252.803 169.487Z",
    fill: "url(#paint5_linear_6200_202126)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M248.498 173.117L246.266 175.003C246.801 173.743 247.623 168.612 247.623 168.612L248.289 169.265L248.498 173.117Z",
    fill: "url(#paint6_linear_6200_202126)"
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M268.969 162.58C268.877 164.859 267.31 182.615 267.493 187.72C267.604 190.729 268.681 195.024 268.681 195.508C268.681 195.84 268.244 196.193 268.074 196.291C267.448 196.65 266.22 196.905 264.732 197.087C261.801 197.446 257.845 197.512 255.462 197.512C252.257 197.512 247.452 197.002 246.845 196.193C246.29 195.455 246.786 194.378 247.067 192.896C249.117 181.916 247.054 163.782 247.4 161.484C248.68 160.635 254.587 158.742 254.679 158.716C255.534 158.664 255.704 158.246 256.702 158.272C257.571 158.298 259.49 158.416 260.939 158.605C260.939 158.605 266.227 159.897 268.982 162.587L268.969 162.58Z",
    fill: "url(#paint7_linear_6200_202126)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M247.686 146.717C247.686 146.717 248.091 151.6 249.71 151.933C251.329 152.26 250.931 150.184 250.931 150.184L250.702 147.866L247.68 146.717H247.686Z",
    fill: "url(#paint8_linear_6200_202126)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M255.741 162.574C252.549 162.443 253.658 159.636 254.67 158.709C254.709 158.651 254.742 158.54 254.762 158.39C254.859 157.639 254.742 155.909 254.683 154.988C254.664 154.714 254.651 154.512 254.651 154.427L256.531 153.108L260.441 150.334C260.441 150.334 260.617 154.61 260.93 158.598C261.42 159.917 258.992 162.711 255.741 162.574Z",
    fill: "#FFA49A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M258.215 154.323C258.215 154.323 257.19 157.626 254.762 158.389C254.86 157.639 254.742 155.909 254.684 154.988L258.215 154.323Z",
    fill: "#FF8189"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M249.132 146.456C249.132 146.456 248.623 156.934 252.396 157.639C252.396 157.639 255.412 158.043 257.919 154.675C258.644 153.702 259.551 153.487 259.851 152.312C260.334 150.406 261.02 146.9 260.145 144.779C258.905 141.763 249.25 139.112 249.132 146.45V146.456Z",
    fill: "#FFA49A"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M260.192 143.806C261.184 139.915 255.694 136.24 248.598 141.671C247.861 141.162 246.503 140.686 245.85 141.143C245.06 141.691 244.91 143.688 245.393 145.059C246.425 147.99 250.224 148.656 253.162 147.906C255.205 147.383 256.282 146.215 256.993 146.3C256.347 149.159 257.64 151.581 258.652 151.411C258.776 151.646 259.415 150.621 259.454 150.961C259.533 151.705 260.205 152.952 260.962 151.509C262.098 149.348 263.13 143.904 260.192 143.812V143.806Z",
    fill: "url(#paint9_linear_6200_202126)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M259.279 153.617C260.708 153.957 262.249 149.564 260.402 149.348C258.998 149.185 258.456 151.418 258.456 151.418C258.456 151.418 258.117 153.343 259.279 153.617Z",
    fill: "#FFA49A"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M276.145 181.466C276.145 181.466 276.145 181.414 276.132 181.381C275.884 179.736 275.538 178.195 275.433 177.771C275.42 177.699 275.414 177.66 275.414 177.66C274.611 173.678 272.986 169.84 272.986 169.84L266.405 173.202C266.405 173.202 267.717 178.672 269.101 182.328C269.101 182.328 263.781 186.754 260.393 189.339C258.728 190.612 257.475 191.558 256.626 192.191C256.626 192.191 253.63 193.366 251.991 194.248C251.358 194.587 248.499 199.209 248.584 199.424C248.662 199.64 249.015 199.829 249.478 199.62C249.654 199.542 249.948 199.248 250.229 198.87C250.229 198.87 249.929 199.379 249.981 199.548C250.027 199.712 250.288 199.81 250.647 199.666C250.98 199.535 251.247 199.183 251.541 198.713C251.502 198.83 251.476 198.922 251.463 198.948C251.424 199.092 251.73 199.385 252.331 199.105C252.762 198.902 253.46 197.486 253.65 197.264C253.721 197.179 253.969 197.094 254.289 197.029L253.519 199.509C253.519 199.509 253.591 199.783 254.283 199.614C254.896 199.457 255.601 197.76 255.941 196.839C258.206 196.65 258.918 194.248 258.918 194.248C261.424 192.74 265.459 191.388 270.322 189.286C272.326 188.425 274.317 187.008 275.205 186.466C275.244 186.44 275.845 186.081 275.884 186.055C276.145 185.918 276.295 185.539 276.354 185.004C276.458 184.09 276.334 182.752 276.145 181.466Z",
    fill: "#FFA49A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M263.667 169.01C264.372 171.928 266.872 177.888 266.872 177.888C267.995 177.921 270.214 177.497 271.905 176.811C274.353 175.819 275.3 174.605 275.3 174.605C275.3 174.605 273.746 170.531 272.525 167.542C271.683 165.485 270.58 163.527 270.038 163.037C267.747 160.974 266.004 160.446 264.515 159.826L263.66 169.01H263.667Z",
    fill: "url(#paint10_linear_6200_202126)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M261.29 200.913H250.238V199.829H261.29C261.59 199.829 261.832 200.071 261.832 200.371C261.832 200.671 261.59 200.913 261.29 200.913Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M255.359 199.881L249.713 179.56C249.543 178.959 249.001 178.541 248.375 178.541H221.61C221.42 178.541 221.251 178.62 221.127 178.737L220.48 179.246L220.97 179.579L226.597 199.829C226.689 200.149 226.976 200.371 227.309 200.371H254.987C255.249 200.371 255.431 200.123 255.366 199.875L255.359 199.881Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M254.309 200.913H226.63C226.297 200.913 226.01 200.691 225.919 200.371L220.252 179.977C220.128 179.527 220.468 179.077 220.938 179.077H247.702C248.329 179.077 248.871 179.494 249.041 180.095L254.687 200.417C254.759 200.665 254.57 200.913 254.309 200.913Z",
    fill: "url(#paint11_linear_6200_202126)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M220.333 166.38C220.333 166.38 220.3 166.367 220.287 166.36C220.463 166.164 220.242 165.531 219.497 165.244C218.616 164.904 218.394 164.839 218.394 164.839L217.421 164.363L217.134 163.351C217.134 163.351 216.227 164.924 216.246 165.355C216.266 165.786 217.102 167.803 217.852 168.194C218.603 168.586 219.726 169.017 220.091 169.017C220.392 169.017 220.49 168.704 220.215 168.371C220.503 168.443 220.757 168.501 220.855 168.501C221.188 168.501 221.116 167.888 220.542 167.496C220.738 167.542 220.894 167.574 220.973 167.574C221.364 167.574 221.208 166.732 220.326 166.393L220.333 166.38Z",
    fill: "#D99490"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M315.152 242.692L314.238 238.899C315.798 239.167 318.338 238.409 319.363 238.272L319.258 242.692C319.258 242.692 317.339 243.88 315.152 242.692Z",
    fill: "#F3B2AD"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M295.174 242.692L295.004 239.806C296.564 240.074 298.366 239.911 299.391 239.78L299.286 242.692C299.286 242.692 297.367 243.88 295.18 242.692H295.174Z",
    fill: "#F3B2AD"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M319.724 239.003C318.653 239.617 315.533 240.094 314.025 239.604C314.025 239.604 307.321 209.21 306.466 205.469C305.343 200.586 303.391 194.691 302.229 189.365C302.242 192.126 302 195.716 301.733 198.771V198.785C301.426 202.316 301.093 205.13 301.093 205.13C301.328 207.362 301.792 218.179 300.897 225.053C300.316 229.479 300.284 239.78 300.284 239.78C299.089 240.054 296.739 240.283 294.395 239.852C294.395 239.852 290.72 205.894 290.557 203.25C289.885 192.133 290.368 167.502 290.42 167.019C290.42 167.196 291.699 168.305 295.623 168.083C301.028 167.783 311.224 167.013 311.224 167.013C314.214 168.697 314.776 177.347 314.665 181.531C314.541 183.503 315.559 196.937 316.205 204.64C318.177 209.275 318.196 217.174 318.582 222.971C319.189 232.012 319.711 239.003 319.711 239.003H319.724Z",
    fill: "url(#paint12_linear_6200_202126)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M287.33 142.624L285.287 153.141C282.76 151.091 278.837 148.036 276.187 146.554L274.117 147.768C274.117 147.768 276.363 150.843 279.503 154.277C283.609 158.768 285.841 160.615 285.841 160.615C286.409 161.157 287.245 161.32 288.485 160.661C292.5 158.527 294.739 145.679 294.739 145.679L287.33 142.618V142.624Z",
    fill: "#F3B2AD"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M284.961 148.858C284.961 148.858 286.678 150.027 289.067 150.784C289.72 150.993 290.425 151.169 291.163 151.28C291.535 151.346 291.913 151.385 292.298 151.404C292.814 151.424 293.362 151.424 293.911 151.385C294.087 151.365 294.263 151.346 294.433 151.326L295.824 145.66L296.855 141.469L289.792 133.302C289.792 133.302 287.944 136.423 284.961 148.865V148.858Z",
    fill: "url(#paint13_linear_6200_202126)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M292.514 110.748H293.826C293.826 110.748 293.911 111.14 293.95 111.603L295.458 112.485V114.9C295.458 114.9 295.647 117.08 294.009 116.578C293.043 116.277 292.866 114.397 292.879 112.909C291.92 112.282 292.514 110.748 292.514 110.748Z",
    fill: "url(#paint14_linear_6200_202126)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M305.16 128.635C304.847 127.897 304.553 118.843 304.553 118.843L300.512 122.237L298.606 123.837C298.397 124.79 298.064 126.011 297.783 127.003C297.489 128.015 297.666 128.902 297.666 128.902C297.666 128.902 298.482 130.423 300.394 130.273C304.109 129.993 305.153 128.635 305.153 128.635H305.16Z",
    fill: "#F3B2AD"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M303.022 122.244C303.022 122.244 301.403 125.821 297.793 127.003C298.08 126.017 298.413 124.796 298.616 123.843L300.522 122.237H303.022V122.244Z",
    fill: "#D76B66"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M293.688 114.404C293.688 114.404 292.879 122.916 295.653 124.463C297.181 125.312 300.399 124.986 302.494 123.034C303.408 122.179 303.957 121.004 304.387 119.822C305.086 117.909 306.15 114.358 305.471 112.086C304.505 108.848 294.569 106.844 293.688 114.404Z",
    fill: "#F3B2AD"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M294.738 106.381C296.344 106.054 296.52 104.775 298.303 104.958C300.085 105.141 300.352 106.087 301.188 106.414C302.023 106.74 303.009 106.453 304.099 107.099C304.798 107.517 305.039 108.254 305.124 108.737C308.427 109.24 308.127 111.512 307.357 114.064C306.776 115.977 307.657 116.565 306.946 117.948C306.645 118.536 305.855 119.43 305.699 120.22C305.438 121.532 305.32 122.009 304.713 122.577C304.471 121.206 304.001 120.142 303.577 117.87C303.544 117.7 303.505 117.55 303.466 117.4C302.245 117.283 301.449 117.505 301.175 116.656C300.953 115.951 301.038 114.991 300.953 114.097C298.107 114.293 297.336 113.131 296.971 112.844C293.903 113.522 292.701 113.229 291.977 112.158C291.2 111.016 291.912 110.285 291.899 109.939C291.899 109.926 291.892 109.919 291.892 109.913C291.664 108.346 293.139 106.707 294.745 106.381H294.738Z",
    fill: "url(#paint15_linear_6200_202126)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M290.585 168.586C291.792 170.107 296.44 171.321 299.92 171.321C303.843 171.321 311.272 169.859 312.362 168.371C312.48 168.207 313.198 167.502 312.049 163.194C311.768 162.15 311.331 159.558 311.272 158.631C310.946 153.48 312.427 146.3 312.956 144.733C314.288 140.796 315.561 137.617 315.026 134.471C314.418 133.426 314.092 132.682 313.446 131.971C311.833 130.195 306.245 127.59 304.979 127.375C304.979 127.375 303.706 129.764 300.69 129.999C296.995 130.286 297.707 127.375 297.707 127.375C295.513 128.491 292.759 129.882 290.839 131.827C289.266 133.426 288.078 137.03 289.09 143.767C289.403 145.862 289.958 153.755 290.193 160.106C290.356 164.395 290.095 167.979 290.578 168.593L290.585 168.586Z",
    fill: "url(#paint16_linear_6200_202126)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M308.559 141.443C308.559 141.443 310.406 146.091 312.364 149.838C313.037 151.117 314.342 155.132 314.884 155.491C316.627 156.64 319.61 154.1 320.785 152.958C320.792 152.867 320.361 150.19 319.421 147.057C317.985 142.278 315.831 136.357 315.831 136.357L308.559 141.443Z",
    fill: "#F3B2AD"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M307.446 132.708C308.399 131.468 311.591 129.712 313.693 132.317C314.091 132.806 316.311 136.573 317.42 139.772C318.569 143.094 319.398 145.725 319.398 145.725C319.398 145.725 317.244 146.861 314.999 147.638C313.119 148.277 310.945 148.767 309.287 148.369C309.287 148.369 307.074 142.52 306.538 139.295C306.538 139.295 305.729 134.947 307.446 132.708Z",
    fill: "url(#paint17_linear_6200_202126)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M320.785 152.952C320.785 152.952 310.373 148.388 308.865 147.507C306.607 146.189 305.203 145.288 304.407 144.759C304.407 144.759 302.625 141.397 302.187 140.555C301.75 139.713 300.066 139.523 298.891 138.818C297.722 138.113 296.9 136.991 296.351 137.18C295.803 137.369 296.554 138.858 297.115 139.328C297.676 139.804 298.943 140.783 298.943 140.783C298.943 140.783 298.355 141.652 298.355 141.985C298.355 142.317 297.84 142.69 297.813 143.297C297.787 143.904 297.487 144.184 297.605 144.798C297.722 145.405 298.349 146.548 298.59 146.861C298.708 147.011 299.054 146.939 299.171 146.737C299.289 146.535 299.361 146.195 299.38 146.097C299.452 146.11 300.451 147.52 302.194 147.755C302.305 147.768 302.409 147.768 302.507 147.755C306.189 152.24 309.596 155.595 315.818 158.97C320.289 161.392 321.53 155.445 320.792 152.952H320.785Z",
    fill: "#F3B2AD"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M292.408 242.476C292.408 242.476 294.399 240.87 295.065 240.87C295.581 240.87 295.835 241.19 296.312 241.367C296.645 241.491 296.932 241.51 297.017 241.51C298.721 241.53 299.348 241.034 299.348 241.034C300.947 243.952 299.987 246.308 299.987 246.308H286.984C286.618 243.221 290.789 242.999 292.415 242.47L292.408 242.476Z",
    fill: "#283770"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M313.535 241.797C313.535 241.797 314.037 241.23 315.017 240.87C315.865 240.564 316.89 240.361 318.62 241.034C319.084 241.047 319.305 240.994 319.305 240.994C319.436 241.432 319.684 241.778 319.978 242.085C322.465 244.696 320.996 246.308 320.996 246.308H313.855C310.467 245.819 311.903 242.32 313.528 241.791L313.535 241.797Z",
    fill: "#283770"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M302.665 120.729C304.604 121.787 305.916 116.845 304.004 116.362C302.554 115.997 302.222 118.04 302.222 118.04C302.222 118.04 301.556 120.129 302.665 120.729Z",
    fill: "#F3B2AD"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M302.233 189.365C302.24 190.422 302.207 191.597 302.148 192.818L298.989 181.995C298.166 180.695 297.435 179.873 297.344 179.768L300.275 180.911C300.725 183.313 302.233 189.365 302.233 189.365Z",
    fill: "url(#paint18_linear_6200_202126)"
  }), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M294.691 154.988H280.244C279.487 154.988 278.782 154.577 278.417 153.911L269.369 137.585C269.068 137.043 269.46 136.383 270.08 136.383H284.527C285.284 136.383 285.989 136.795 286.355 137.461L295.402 153.787C295.703 154.329 295.311 154.988 294.691 154.988Z",
    fill: "url(#paint19_linear_6200_202126)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M276.982 147.011C277.628 146.92 277.406 146.3 276.897 146.012C276.688 145.895 276.362 145.784 276.022 145.686C277.354 145.934 277.138 145.059 276.512 144.707C275.885 144.354 274.227 144.054 274.227 144.054L272.373 143.016L271.544 141.521C271.544 141.521 271.126 143.447 271.59 144.211C271.564 144.563 271.537 145.144 271.609 145.281C271.642 145.34 271.714 145.412 271.799 145.477C271.851 145.999 271.949 146.535 272.164 146.678C272.223 146.717 272.282 146.75 272.34 146.789C272.38 147.109 272.471 147.39 272.66 147.52C273.293 147.951 274.207 148.238 274.207 148.238C274.207 148.238 275.082 148.356 276.185 148.558C277.073 148.721 277.125 148.291 276.851 147.964C277.615 147.945 277.452 147.337 276.975 147.005L276.982 147.011Z",
    fill: "#F3B2AD"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M102.439 24H54.3411C51.9436 24 50 25.9436 50 28.3411V47.9969C50 50.3944 51.9436 52.338 54.3411 52.338H102.439C104.837 52.338 106.78 50.3944 106.78 47.9969V28.3411C106.78 25.9436 104.837 24 102.439 24Z",
    fill: "url(#paint20_linear_6200_202126)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2111 37.6889C61.9187 37.6889 64.1136 35.494 64.1136 32.7864C64.1136 30.0788 61.9187 27.8839 59.2111 27.8839C56.5035 27.8839 54.3086 30.0788 54.3086 32.7864C54.3086 35.494 56.5035 37.6889 59.2111 37.6889Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M59.21 32.7864C60.0788 32.7864 60.7832 32.0821 60.7832 31.2132C60.7832 30.3443 60.0788 29.64 59.21 29.64C58.3411 29.64 57.6367 30.3443 57.6367 31.2132C57.6367 32.0821 58.3411 32.7864 59.21 32.7864Z",
    fill: "url(#paint21_linear_6200_202126)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M62.489 36.442C61.6208 37.2189 60.4718 37.6889 59.2184 37.6889C57.9651 37.6889 56.8096 37.2124 55.9414 36.4355C55.9936 34.673 57.4363 33.2564 59.2184 33.2564C60.1258 33.2564 60.9418 33.622 61.5359 34.216C62.1299 34.8101 62.4694 35.5673 62.4955 36.4355L62.489 36.442Z",
    fill: "url(#paint22_linear_6200_202126)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6033 31.2134H66.6382C66.3249 31.2134 66.0703 30.9588 66.0703 30.6455C66.0703 30.3321 66.3249 30.0775 66.6382 30.0775H84.6033C84.9166 30.0775 85.1712 30.3321 85.1712 30.6455C85.1712 30.9588 84.9166 31.2134 84.6033 31.2134Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6033 33.3481H66.6382C66.3249 33.3481 66.0703 33.0935 66.0703 32.7802C66.0703 32.4668 66.3249 32.2122 66.6382 32.2122H84.6033C84.9166 32.2122 85.1712 32.4668 85.1712 32.7802C85.1712 33.0935 84.9166 33.3481 84.6033 33.3481Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7721 35.4893H66.6382C66.3249 35.4893 66.0703 35.2347 66.0703 34.9213C66.0703 34.608 66.3249 34.3534 66.6382 34.3534H74.7721C75.0855 34.3534 75.3401 34.608 75.3401 34.9213C75.3401 35.2347 75.0855 35.4893 74.7721 35.4893Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6749 35.4893H76.6304C76.3171 35.4893 76.0625 35.2347 76.0625 34.9213C76.0625 34.608 76.3171 34.3534 76.6304 34.3534H77.6749C77.9883 34.3534 78.2428 34.608 78.2428 34.9213C78.2428 35.2347 77.9883 35.4893 77.6749 35.4893Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3586 48.3861C101.031 47.9514 102.845 45.4325 102.41 42.76C101.976 40.0875 99.4567 38.2735 96.7842 38.7083C94.1118 39.143 92.2978 41.6619 92.7325 44.3344C93.1673 47.0068 95.6862 48.8209 98.3586 48.3861Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9922 41.9778C95.9922 42.8461 96.6972 43.5511 97.5654 43.5511C98.4337 43.5511 99.1387 42.8461 99.1387 41.9778C99.1387 41.1096 98.4337 40.4046 97.5654 40.4046C96.6972 40.4046 95.9922 41.1096 95.9922 41.9778Z",
    fill: "url(#paint23_linear_6200_202126)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2917 47.2067C95.1599 47.9835 96.3088 48.4536 97.5622 48.4536C98.8156 48.4536 99.971 47.977 100.839 47.2002C100.787 45.4376 99.3444 44.0211 97.5622 44.0211C96.6548 44.0211 95.8388 44.3866 95.2448 44.9807C94.6768 45.5486 94.3113 46.332 94.2852 47.2002L94.2917 47.2067Z",
    fill: "url(#paint24_linear_6200_202126)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1773 41.9779H90.1423C90.4557 41.9779 90.7103 41.7233 90.7103 41.41C90.7103 41.0966 90.4557 40.842 90.1423 40.842H72.1773C71.864 40.842 71.6094 41.0966 71.6094 41.41C71.6094 41.7233 71.864 41.9779 72.1773 41.9779Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2945 41.9779H70.1354C70.4487 41.9779 70.7033 41.7233 70.7033 41.41C70.7033 41.0966 70.4487 40.842 70.1354 40.842H68.2945C67.9812 40.842 67.7266 41.0966 67.7266 41.41C67.7266 41.7233 67.9812 41.9779 68.2945 41.9779Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1773 44.1126H90.1423C90.4557 44.1126 90.7103 43.858 90.7103 43.5447C90.7103 43.2313 90.4557 42.9767 90.1423 42.9767H72.1773C71.864 42.9767 71.6094 43.2313 71.6094 43.5447C71.6094 43.858 71.864 44.1126 72.1773 44.1126Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0054 46.2538H90.1393C90.4526 46.2538 90.7072 45.9992 90.7072 45.6859C90.7072 45.3725 90.4526 45.1179 90.1393 45.1179H82.0054C81.6921 45.1179 81.4375 45.3725 81.4375 45.6859C81.4375 45.9992 81.6921 46.2538 82.0054 46.2538Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5331 96.4518H39.6764C36.073 96.4518 33.1484 93.5273 33.1484 89.9239C33.1484 86.3204 36.073 83.3959 39.6764 83.3959H87.5331C91.1365 83.3959 94.0611 86.3204 94.0611 89.9239C94.0611 93.5273 91.1365 96.4518 87.5331 96.4518Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M42.913 87.2017L43.5854 88.5595C43.6376 88.664 43.7355 88.7358 43.8465 88.7488L45.348 88.9642C45.6352 89.0034 45.7462 89.3559 45.5438 89.5583L44.4602 90.6158C44.3753 90.6942 44.3426 90.8117 44.3622 90.9226L44.6168 92.4176C44.6625 92.7048 44.3688 92.9202 44.1142 92.7831L42.7694 92.0781C42.665 92.0259 42.5474 92.0259 42.443 92.0781L41.0982 92.7831C40.8436 92.9202 40.5434 92.6983 40.5956 92.4176L40.8502 90.9226C40.8698 90.8117 40.8306 90.6942 40.7523 90.6158L39.6686 89.5583C39.4597 89.3559 39.5772 89.0034 39.8644 88.9642L41.3659 88.7488C41.4769 88.7292 41.5748 88.664 41.627 88.5595L42.2994 87.2017C42.4299 86.9406 42.7955 86.9406 42.9261 87.2017H42.913Z",
    fill: "url(#paint25_linear_6200_202126)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M53.413 87.2017L54.0854 88.5595C54.1376 88.664 54.2355 88.7358 54.3465 88.7488L55.848 88.9642C56.1352 89.0034 56.2462 89.3559 56.0438 89.5583L54.9601 90.6158C54.8753 90.6942 54.8426 90.8117 54.8622 90.9226L55.1168 92.4176C55.1625 92.7048 54.8688 92.9202 54.6142 92.7831L53.2694 92.0781C53.165 92.0259 53.0474 92.0259 52.943 92.0781L51.5982 92.7831C51.3436 92.9202 51.0434 92.6983 51.0956 92.4176L51.3502 90.9226C51.3698 90.8117 51.3306 90.6942 51.2522 90.6158L50.1686 89.5583C49.9597 89.3559 50.0772 89.0034 50.3644 88.9642L51.8659 88.7488C51.9769 88.7292 52.0748 88.664 52.127 88.5595L52.7994 87.2017C52.9299 86.9406 53.2955 86.9406 53.4261 87.2017H53.413Z",
    fill: "url(#paint26_linear_6200_202126)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M63.913 87.2017L64.5854 88.5595C64.6376 88.664 64.7355 88.7358 64.8465 88.7488L66.348 88.9642C66.6352 89.0034 66.7462 89.3559 66.5438 89.5583L65.4602 90.6158C65.3753 90.6942 65.3426 90.8117 65.3622 90.9226L65.6168 92.4176C65.6625 92.7048 65.3688 92.9202 65.1142 92.7831L63.7694 92.0781C63.665 92.0259 63.5474 92.0259 63.443 92.0781L62.0982 92.7831C61.8436 92.9202 61.5434 92.6983 61.5956 92.4176L61.8502 90.9226C61.8698 90.8117 61.8306 90.6942 61.7523 90.6158L60.6686 89.5583C60.4597 89.3559 60.5772 89.0034 60.8644 88.9642L62.3659 88.7488C62.4769 88.7292 62.5748 88.664 62.627 88.5595L63.2994 87.2017C63.4299 86.9406 63.7955 86.9406 63.9261 87.2017H63.913Z",
    fill: "url(#paint27_linear_6200_202126)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4091 87.2017L75.0815 88.5595C75.1337 88.664 75.2316 88.7358 75.3426 88.7488L76.844 88.9642C77.1313 89.0034 77.2423 89.3559 77.0399 89.5583L75.9562 90.6158C75.8714 90.6942 75.8387 90.8117 75.8583 90.9226L76.1129 92.4176C76.1586 92.7048 75.8648 92.9202 75.6103 92.7831L74.2655 92.0781C74.161 92.0259 74.0435 92.0259 73.9391 92.0781L72.5943 92.7831C72.3397 92.9202 72.0394 92.6983 72.0917 92.4176L72.3463 90.9226C72.3658 90.8117 72.3267 90.6942 72.2483 90.6158L71.1647 89.5583C70.9558 89.3559 71.0733 89.0034 71.3605 88.9642L72.862 88.7488C72.973 88.7292 73.0709 88.664 73.1231 88.5595L73.7955 87.2017C73.926 86.9406 74.2916 86.9406 74.4222 87.2017H74.4091Z",
    fill: "url(#paint28_linear_6200_202126)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9091 87.2017L85.5815 88.5595C85.6337 88.664 85.7316 88.7358 85.8426 88.7488L87.344 88.9642C87.6313 89.0034 87.7423 89.3559 87.5399 89.5583L86.4562 90.6158C86.3714 90.6942 86.3387 90.8117 86.3583 90.9226L86.6129 92.4176C86.6586 92.7048 86.3648 92.9202 86.1103 92.7831L84.7655 92.0781C84.661 92.0259 84.5435 92.0259 84.4391 92.0781L83.0943 92.7831C82.8397 92.9202 82.5394 92.6983 82.5917 92.4176L82.8463 90.9226C82.8658 90.8117 82.8267 90.6942 82.7483 90.6158L81.6647 89.5583C81.4558 89.3559 81.5733 89.0034 81.8605 88.9642L83.362 88.7488C83.473 88.7292 83.5709 88.664 83.6231 88.5595L84.2955 87.2017C84.426 86.9406 84.7916 86.9406 84.9222 87.2017H84.9091Z",
    fill: "url(#paint29_linear_6200_202126)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6374 211.227H25.0625V245.824H32.6374V211.227Z",
    fill: "url(#paint30_linear_6200_202126)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M44.821 216.776H37.2461V245.825H44.821V216.776Z",
    fill: "url(#paint31_linear_6200_202126)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M20.575 221.513H13V245.825H20.575V221.513Z",
    fill: "url(#paint32_linear_6200_202126)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9984 206.627H49.418V245.824H56.9984V206.627Z",
    fill: "url(#paint33_linear_6200_202126)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8187 218.61C17.8561 218.61 18.7014 217.764 18.7014 216.727C18.7014 216.43 18.6246 216.15 18.5038 215.903L27.8408 206.896C28.1317 207.082 28.4775 207.192 28.8453 207.192C29.3777 207.192 29.8608 206.967 30.2011 206.605L39.1648 211.957C39.1483 212.05 39.1373 212.143 39.1373 212.237C39.1373 213.274 39.9827 214.119 41.0201 214.119C42.0575 214.119 42.9029 213.274 42.9029 212.237C42.9029 211.907 42.8095 211.6 42.6613 211.326L52.4758 199.623C52.7009 199.716 52.9424 199.766 53.2004 199.766C54.2378 199.766 55.0831 198.92 55.0831 197.883C55.0831 196.845 54.2378 196 53.2004 196C52.163 196 51.3176 196.845 51.3176 197.883C51.3176 198.256 51.4274 198.602 51.6195 198.893L41.8489 210.546C41.6019 210.425 41.322 210.348 41.0311 210.348C40.4986 210.348 40.0156 210.574 39.6753 210.93L30.7116 205.578C30.728 205.485 30.739 205.392 30.739 205.299C30.739 204.261 29.8937 203.416 28.8563 203.416C27.8188 203.416 26.9735 204.261 26.9735 205.299C26.9735 205.557 27.0284 205.798 27.1162 206.023L17.7299 215.075C17.4609 214.926 17.1535 214.833 16.8242 214.833C15.7867 214.833 14.9414 215.678 14.9414 216.716C14.9414 217.753 15.7867 218.599 16.8242 218.599L16.8187 218.61Z",
    fill: "url(#paint34_linear_6200_202126)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M280.918 107.824H266.302C264.664 107.824 263.332 109.155 263.332 110.794V114.45C263.332 116.088 264.664 117.42 266.302 117.42H276.858L279.502 120.064C279.848 120.41 280.442 120.168 280.442 119.672V117.42H280.912C282.55 117.42 283.882 116.088 283.882 114.45V110.794C283.882 109.155 282.55 107.824 280.912 107.824H280.918Z",
    fill: "url(#paint35_linear_6200_202126)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M269.313 112.602C269.313 113.085 268.922 113.483 268.432 113.483C267.942 113.483 267.551 113.092 267.551 112.602C267.551 112.113 267.942 111.721 268.432 111.721C268.922 111.721 269.313 112.113 269.313 112.602Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M272.763 112.602C272.763 113.085 272.371 113.483 271.881 113.483C271.392 113.483 271 113.092 271 112.602C271 112.113 271.392 111.721 271.881 111.721C272.371 111.721 272.763 112.113 272.763 112.602Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M276.22 112.602C276.22 113.085 275.828 113.483 275.338 113.483C274.849 113.483 274.457 113.092 274.457 112.602C274.457 112.113 274.849 111.721 275.338 111.721C275.828 111.721 276.22 112.113 276.22 112.602Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M279.677 112.602C279.677 113.085 279.285 113.483 278.795 113.483C278.306 113.483 277.914 113.092 277.914 112.602C277.914 112.113 278.306 111.721 278.795 111.721C279.285 111.721 279.677 112.113 279.677 112.602Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M256.007 118.882H273.254C274.892 118.882 276.224 120.214 276.224 121.852V125.508C276.224 127.146 274.892 128.478 273.254 128.478H260.067L257.423 131.122C257.077 131.468 256.483 131.226 256.483 130.73V128.478H256.013C254.375 128.478 253.043 127.146 253.043 125.508V121.852C253.043 120.214 254.375 118.882 256.013 118.882H256.007Z",
    fill: "url(#paint36_linear_6200_202126)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M270.254 123.66C270.254 124.144 270.646 124.542 271.135 124.542C271.625 124.542 272.016 124.15 272.016 123.66C272.016 123.171 271.625 122.779 271.135 122.779C270.646 122.779 270.254 123.171 270.254 123.66Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M266.793 123.66C266.793 124.144 267.185 124.542 267.674 124.542C268.164 124.542 268.556 124.15 268.556 123.66C268.556 123.171 268.164 122.779 267.674 122.779C267.185 122.779 266.793 123.171 266.793 123.66Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M263.34 123.66C263.34 124.144 263.732 124.542 264.221 124.542C264.711 124.542 265.102 124.15 265.102 123.66C265.102 123.171 264.711 122.779 264.221 122.779C263.732 122.779 263.34 123.171 263.34 123.66Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M259.879 123.66C259.879 124.144 260.271 124.542 260.76 124.542C261.25 124.542 261.641 124.15 261.641 123.66C261.641 123.171 261.25 122.779 260.76 122.779C260.271 122.779 259.879 123.171 259.879 123.66Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M256.426 123.66C256.426 124.144 256.817 124.542 257.307 124.542C257.797 124.542 258.188 124.15 258.188 123.66C258.188 123.171 257.797 122.779 257.307 122.779C256.817 122.779 256.426 123.171 256.426 123.66Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7096 175.493H94.8817C94.2977 175.493 93.8242 175.966 93.8242 176.55V184.058C93.8242 184.642 94.2977 185.115 94.8817 185.115H96.7096C97.2936 185.115 97.7671 184.642 97.7671 184.058V176.55C97.7671 175.966 97.2936 175.493 96.7096 175.493Z",
    fill: "url(#paint37_linear_6200_202126)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M108.704 181.257C108.482 182.556 107.301 182.837 107.301 182.837C107.301 182.837 108.077 182.908 107.888 183.666C107.699 184.423 107.039 185.115 106.445 185.115H101.621C100.825 185.115 100.035 184.958 99.3103 184.632C99.2646 184.612 99.2189 184.593 99.1732 184.573C98.8729 184.449 98.6836 184.149 98.6836 183.822V176.831C98.6836 176.505 98.7619 176.185 98.9186 175.897C99.2515 175.271 99.826 174.096 99.826 173.469C99.826 172.581 98.4812 169.742 99.4147 169.154C100.329 168.58 101.523 169.363 102.307 170.779C102.927 171.896 102.483 174.324 102.927 174.768H107.594C107.594 174.768 108.861 174.722 108.776 175.891C108.704 176.896 108.156 177.471 108.156 177.471C108.156 177.471 108.985 177.412 108.952 178.489C108.926 179.52 108.123 180.232 108.123 180.232C108.123 180.232 108.861 180.343 108.704 181.25V181.257Z",
    fill: "url(#paint38_linear_6200_202126)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M149.666 49.7114H145.939C145.701 49.7114 145.508 49.9043 145.508 50.1423V53.8698C145.508 54.1077 145.701 54.3006 145.939 54.3006H149.666C149.904 54.3006 150.097 54.1077 150.097 53.8698V50.1423C150.097 49.9043 149.904 49.7114 149.666 49.7114Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M155.795 49.7114H152.068C151.83 49.7114 151.637 49.9043 151.637 50.1423V53.8698C151.637 54.1077 151.83 54.3006 152.068 54.3006H155.795C156.033 54.3006 156.226 54.1077 156.226 53.8698V50.1423C156.226 49.9043 156.033 49.7114 155.795 49.7114Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M161.936 49.7114H158.208C157.97 49.7114 157.777 49.9043 157.777 50.1423V53.8698C157.777 54.1077 157.97 54.3006 158.208 54.3006H161.936C162.174 54.3006 162.367 54.1077 162.367 53.8698V50.1423C162.367 49.9043 162.174 49.7114 161.936 49.7114Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M200.959 224.446H198.57C198.415 224.446 198.289 224.572 198.289 224.727V227.116C198.289 227.271 198.415 227.397 198.57 227.397H200.959C201.114 227.397 201.24 227.271 201.24 227.116V224.727C201.24 224.572 201.114 224.446 200.959 224.446Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M204.912 224.446H202.523C202.368 224.446 202.242 224.572 202.242 224.727V227.116C202.242 227.271 202.368 227.397 202.523 227.397H204.912C205.067 227.397 205.193 227.271 205.193 227.116V224.727C205.193 224.572 205.067 224.446 204.912 224.446Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M208.854 224.446H206.464C206.309 224.446 206.184 224.572 206.184 224.727V227.116C206.184 227.271 206.309 227.397 206.464 227.397H208.854C209.009 227.397 209.134 227.271 209.134 227.116V224.727C209.134 224.572 209.009 224.446 208.854 224.446Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M0.796875 121.735C0.796875 125.175 3.58432 127.969 7.0311 127.969H45.853C49.2933 127.969 52.0873 125.181 52.0873 121.735C52.0873 118.294 49.2998 115.5 45.853 115.5H7.0311C3.59085 115.5 0.796875 118.288 0.796875 121.735Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3922 119.535H18.4055C18.0204 119.535 17.707 119.221 17.707 118.836C17.707 118.451 18.0204 118.138 18.4055 118.138H45.3922C45.7774 118.138 46.0907 118.451 46.0907 118.836C46.0907 119.221 45.7774 119.535 45.3922 119.535Z",
    fill: "url(#paint39_linear_6200_202126)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2151 122.446H18.4055C18.0204 122.446 17.707 122.133 17.707 121.748C17.707 121.363 18.0204 121.049 18.4055 121.049H35.2151C35.6002 121.049 35.9136 121.363 35.9136 121.748C35.9136 122.133 35.6002 122.446 35.2151 122.446Z",
    fill: "url(#paint40_linear_6200_202126)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3871 122.446H38.1868C37.8016 122.446 37.4883 122.133 37.4883 121.748C37.4883 121.363 37.8016 121.049 38.1868 121.049H45.3871C45.7723 121.049 46.0856 121.363 46.0856 121.748C46.0856 122.133 45.7723 122.446 45.3871 122.446Z",
    fill: "url(#paint41_linear_6200_202126)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2004 125.364H18.4055C18.0204 125.364 17.707 125.051 17.707 124.666C17.707 124.281 18.0204 123.967 18.4055 123.967H31.2004C31.5855 123.967 31.8989 124.281 31.8989 124.666C31.8989 125.051 31.5855 125.364 31.2004 125.364Z",
    fill: "url(#paint42_linear_6200_202126)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5288 121.278C8.62264 121.278 7.08203 122.818 7.08203 124.725V125.071C7.08203 125.227 7.21259 125.358 7.36926 125.358H13.6884C13.845 125.358 13.9756 125.227 13.9756 125.071V124.725C13.9756 122.818 12.435 121.278 10.5288 121.278Z",
    fill: "url(#paint43_linear_6200_202126)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9962 119.215C11.9962 120.024 11.3369 121.056 10.5274 121.056C9.71792 121.056 9.05859 120.024 9.05859 119.215C9.05859 118.405 9.71792 117.746 10.5274 117.746C11.3369 117.746 11.9962 118.405 11.9962 119.215Z",
    fill: "url(#paint44_linear_6200_202126)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01172 246.569H346.141",
    stroke: "#232230",
    strokeWidth: 0.652799,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6200_202126",
    x1: 172.286,
    y1: -1.05631,
    x2: 172.286,
    y2: 252.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFEDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6200_202126",
    x1: 338.31,
    y1: 233.589,
    x2: 348.135,
    y2: 223.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFEDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6200_202126",
    x1: 235.098,
    y1: 246.197,
    x2: 235.098,
    y2: 215.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#283770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6200_202126",
    x1: 255.145,
    y1: 232.88,
    x2: 255.145,
    y2: 196.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#283770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6200_202126",
    x1: 226.822,
    y1: 161.895,
    x2: 226.822,
    y2: 182.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#283770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6200_202126",
    x1: 245.635,
    y1: 159.773,
    x2: 245.635,
    y2: 197.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49A5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6CEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6200_202126",
    x1: 247.382,
    y1: 168.56,
    x2: 247.382,
    y2: 176.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49A5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6CEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6200_202126",
    x1: 257.773,
    y1: 159.773,
    x2: 257.773,
    y2: 197.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49A5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6CEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6200_202126",
    x1: 249.331,
    y1: 161.758,
    x2: 249.331,
    y2: 149.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#162959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1B38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6200_202126",
    x1: 253.612,
    y1: 154.179,
    x2: 253.612,
    y2: 142.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#162959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1B38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6200_202126",
    x1: 269.483,
    y1: 159.773,
    x2: 269.483,
    y2: 197.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49A5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6CEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6200_202126",
    x1: 237.46,
    y1: 176.093,
    x2: 237.46,
    y2: 206.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51B9F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6200_202126",
    x1: 304.964,
    y1: 172.216,
    x2: 304.964,
    y2: 241.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#283770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6200_202126",
    x1: 290.908,
    y1: 159.532,
    x2: 290.908,
    y2: 111.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49A5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6CEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6200_202126",
    x1: 293.898,
    y1: 121.376,
    x2: 293.898,
    y2: 109.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#162959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1B38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6200_202126",
    x1: 299.732,
    y1: 121.487,
    x2: 299.732,
    y2: 109.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#162959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1B38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_6200_202126",
    x1: 301.937,
    y1: 127.297,
    x2: 301.937,
    y2: 172.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49A5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6CEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_6200_202126",
    x1: 312.87,
    y1: 127.297,
    x2: 312.87,
    y2: 172.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49A5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6CEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_6200_202126",
    x1: 299.583,
    y1: 191.506,
    x2: 299.935,
    y2: 180.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#283770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_6200_202126",
    x1: 282.379,
    y1: 134.967,
    x2: 282.379,
    y2: 153.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#283770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_6200_202126",
    x1: 78.3902,
    y1: 19.9918,
    x2: 78.3902,
    y2: 55.9023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51B9F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_6200_202126",
    x1: 59.21,
    y1: 33.5306,
    x2: 59.21,
    y2: 25.4359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AED2ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_6200_202126",
    x1: 59.2119,
    y1: 42.0561,
    x2: 59.2119,
    y2: 33.9614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AED2ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_6200_202126",
    x1: 97.5654,
    y1: 39.6539,
    x2: 97.5654,
    y2: 47.7486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AED2ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_6200_202126",
    x1: 97.5687,
    y1: 39.6538,
    x2: 97.5687,
    y2: 47.7485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AED2ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_6200_202126",
    x1: 41.6335,
    y1: 90.2176,
    x2: 91.2462,
    y2: 82.0576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_6200_202126",
    x1: 41.9107,
    y1: 91.9018,
    x2: 91.5234,
    y2: 83.7419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_6200_202126",
    x1: 42.1879,
    y1: 93.5795,
    x2: 91.8006,
    y2: 85.4196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_6200_202126",
    x1: 42.4612,
    y1: 95.2638,
    x2: 92.0738,
    y2: 87.1038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_6200_202126",
    x1: 42.7449,
    y1: 96.9415,
    x2: 92.3575,
    y2: 88.7815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_6200_202126",
    x1: 28.85,
    y1: 248.47,
    x2: 28.85,
    y2: 206.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3949B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CA5F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_6200_202126",
    x1: 41.0336,
    y1: 248.47,
    x2: 41.0336,
    y2: 206.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3949B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CA5F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_6200_202126",
    x1: 16.7875,
    y1: 248.47,
    x2: 16.7875,
    y2: 206.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3949B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CA5F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_6200_202126",
    x1: 53.2109,
    y1: 248.47,
    x2: 53.2109,
    y2: 206.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3949B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CA5F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_6200_202126",
    x1: 35.015,
    y1: 218.928,
    x2: 35.015,
    y2: 198.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5954"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0483D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_6200_202126",
    x1: 273.614,
    y1: 121.761,
    x2: 273.614,
    y2: 102.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51B9F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_6200_202126",
    x1: 264.63,
    y1: 115.631,
    x2: 264.63,
    y2: 152.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AED2ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_6200_202126",
    x1: 95.7957,
    y1: 169.729,
    x2: 95.7957,
    y2: 183.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51B9F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_6200_202126",
    x1: 103.815,
    y1: 169.728,
    x2: 103.815,
    y2: 183.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51B9F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_6200_202126",
    x1: 47.2853,
    y1: 113.346,
    x2: 8.85508,
    y2: 127.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6DFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDEAF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_6200_202126",
    x1: 45.7904,
    y1: 114.978,
    x2: 7.35365,
    y2: 128.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6DFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDEAF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_6200_202126",
    x1: 47.4761,
    y1: 119.718,
    x2: 9.03932,
    y2: 133.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6DFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDEAF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_6200_202126",
    x1: 44.6415,
    y1: 117.59,
    x2: 6.20472,
    y2: 131.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6DFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDEAF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_6200_202126",
    x1: 10.5288,
    y1: 117.883,
    x2: 10.5288,
    y2: 127.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51B9F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_6200_202126",
    x1: 10.5274,
    y1: 117.883,
    x2: 10.5274,
    y2: 127.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51B9F8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationImg1);
export default __webpack_public_path__ + "static/media/integration__img1.4d16867ef63e881d8f3e6411c8951d60.svg";
export { ForwardRef as ReactComponent };